// @core/api/endpoints/legalentity/get_legal_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LegalEntityResponse,
} from '../../../types/legalentity';

const BASE_PATH = '/legalentity';

/**
 * Get legal entity by ID
 * Returns full legal entity record including addresses, bank accounts, and default signatory. Requires viewer access on the entity.
 */
export async function GetLegalEntity(
  legal_entity_id: string,
  options?: RequestOptions
): Promise<LegalEntityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:legal_entity_id`;
  requestPath = requestPath.replace(':legal_entity_id', encodeURIComponent(legal_entity_id));
  const requestOptions = options;
  return client.get<LegalEntityResponse>(requestPath, { ...requestOptions });
}
